(function () {
  function closeItem(item) {
    var answer = item.querySelector('.ctr-faq__answer');
    if (!answer) return;
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.getBoundingClientRect();
    answer.style.maxHeight = '0';
    answer.addEventListener('transitionend', function handler() {
      item.removeAttribute('open');
      answer.removeEventListener('transitionend', handler);
    });
  }

  function openItem(item) {
    var answer = item.querySelector('.ctr-faq__answer');
    if (!answer) return;
    item.setAttribute('open', '');
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.addEventListener('transitionend', function handler() {
      answer.style.maxHeight = 'none';
      answer.removeEventListener('transitionend', handler);
    });
  }

  function initSection(container) {
    var items = container.querySelectorAll('.ctr-faq__item');

    items.forEach(function (item) {
      var summary = item.querySelector('.ctr-faq__question');
      if (!summary) return;

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.open) {
          closeItem(item);
        } else {
          items.forEach(function (other) {
            if (other !== item && other.open) closeItem(other);
          });
          openItem(item);
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.ctr-faq').forEach(initSection);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.ctr-faq');
    if (section) initSection(section);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest('.ctr-faq__item');
    if (item && !item.open) openItem(item);
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var item = e.target.closest('.ctr-faq__item');
    if (item && item.open) closeItem(item);
  });
})();
